import { fork } from 'redux-saga/effects';
import watchGeoplaceAssetsDomain from './assets/sagas';

export default function* watchGeoplaceDomains() {
  yield fork(watchGeoplaceAssetsDomain);
}
